export default __webpack_public_path__ + "static/media/Floating_Tube_Rack.a0ee17d7.svg";